import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

export default function SplashPage() {
  return (
    <div className="min-h-dvh bg-bg flex flex-col items-center justify-between px-6 py-16 relative overflow-hidden">
      {/* Star field */}
      <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: `
          radial-gradient(circle at 10% 15%, rgba(255,255,255,0.8) 1px, transparent 1px),
          radial-gradient(circle at 30% 8%,  rgba(255,255,255,0.5) 1px, transparent 1px),
          radial-gradient(circle at 65% 12%, rgba(255,255,255,0.6) 1px, transparent 1px),
          radial-gradient(circle at 80% 25%, rgba(255,255,255,0.4) 1px, transparent 1px),
          radial-gradient(circle at 50% 40%, rgba(255,255,255,0.3) 1px, transparent 1px),
          radial-gradient(ellipse at 50% 0%, rgba(79,110,247,0.15) 0%, transparent 60%),
          radial-gradient(ellipse at 80% 100%, rgba(139,92,246,0.1) 0%, transparent 50%)
        `
      }} />

      <div />

      {/* Center content */}
      <motion.div
        className="flex flex-col items-center text-center gap-6"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        {/* Logo */}
        <motion.div
          className="w-24 h-24 rounded-3xl overflow-hidden shadow-2xl"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          style={{ boxShadow: '0 0 60px rgba(79,110,247,0.3)' }}
        >
          <img src="/icon.png" alt="Timeline" className="w-full h-full object-cover" />
        </motion.div>

        {/* Wordmark */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <h1 className="font-serif text-5xl font-bold text-white tracking-tight mb-2">
            Timeline
          </h1>
          <p className="font-serif text-xl italic text-white/50">
            History in the Making.
          </p>
        </motion.div>

        {/* Divider */}
        <div className="flex items-center gap-3 w-48">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent to-blue/40" />
          <span className="text-blue/60 text-xs">✦</span>
          <div className="flex-1 h-px bg-gradient-to-l from-transparent to-blue/40" />
        </div>

        <p className="font-mono text-xs tracking-[0.15em] text-white/25 lowercase">
          tell your story
        </p>

        {/* Preview dots */}
        <div className="flex gap-2 mt-2">
          {['#4f6ef7','#8b5cf6','#f0b429','#10b981','#f43f5e'].map((c, i) => (
            <motion.div
              key={c}
              className="w-2 h-2 rounded-full"
              style={{ background: c }}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.5 + i * 0.08 }}
            />
          ))}
        </div>
      </motion.div>

      {/* CTAs */}
      <motion.div
        className="w-full flex flex-col gap-3 max-w-sm"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
      >
        <Link to="/signup" className="btn-primary text-center py-4 text-base">
          Create Your Timeline
        </Link>
        <Link to="/login" className="btn-secondary text-center py-4 text-base">
          Sign In
        </Link>
        <p className="text-center font-mono text-[10px] text-white/20 tracking-widest mt-2">
          NO ADS · NO ALGORITHMS · YOUR STORY
        </p>
      </motion.div>
    </div>
  )
}
